import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AppUserView from './view'


const AppUserIndex = () => {
    return (
        <>
            <Routes>
                <Route index element={<AppUserView />} />
            </Routes>
        </>
    )
}

export default AppUserIndex
